module.exports = __webpack_public_path__ + "static/media/edit-photo.0661abcd.svg";